// Module
var code = `<label for="{{inputId}}" class="sr-only">{{labelText}}</label>
<input
  id="{{inputId}}"
  class="peer block w-full rounded-md border border-gray-200 py-[9px] pl-10 text-sm outline-2 placeholder:text-gray-500"
  placeholder="{{attrPlaceholder}}"
  value="{{attrValue}}"
  data-event-type="acmeSearch"
  data-btn-type="{{btnType}}"
/>
{{svgMagnifyingGlass}}
`;
// Exports
module.exports = code;